<script type="text/javascript">

// 環境変数（/config/env.js）から読み込む
const G_NODE_ENV = process.env.NODE_ENV

export default {
  G_NODE_ENV,
  otherPageReplacedMessage: false
}
</script>



// WEBPACK FOOTER //
// src/components/Global.vue